module.exports = "https://cdn.littlereply.com/tt/resource/placehold_people.35cf49070ab39a1c2ce88377ac4aa5f2.png";